import {createStore, applyMiddleware, compose} from 'redux';
import createSagaMiddleware from 'redux-saga';
import rootReducer from './rootReducer';
import rootSaga from './Saga';

const middleware = [];
const enhancers = [];

// const persistConfig = {
//   key: 'root',
//   storage: AsyncStorage,
//   whitelist:['shoppingCart']
// }

const sagaMiddleware = createSagaMiddleware();
middleware.push(sagaMiddleware);

enhancers.push(applyMiddleware(...middleware));

const createAppropriateStore = createStore;
const store = createAppropriateStore(rootReducer, compose(...enhancers));
// kick off root saga
sagaMiddleware.run(rootSaga);

export default store;
